module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Alts-1.dca9357d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Alts-1.otf
// module id = 3465
// module chunks = 70